import React from 'react'
import {change as changeFieldValue} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import QRCode from 'qrcode.react';
import qs from 'qs';
import buscarReserva from '../../actions/reserva/buscarReserva';
import {formatarReal} from '../../util/numberUtil';
import Titulo from '../comum/Titulo';
import ReactToPrint from 'react-to-print';
import {showErrorMsg} from '../../util/messagesUtil';

export class ReciboCancelamentoReserva extends React.Component {
  constructor (props) {
    super(props);
    this.componentRef = React.createRef();
  }

  componentDidMount () {
    const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
    if (this.props.empresaSelecionada.id) {
      if (parametros.reserva) {
        this.props.buscarReserva(parametros.reserva, this.props.empresaSelecionada.id)
          .then(() => {
            if (!this.props.reserva) {
              showErrorMsg('Reserva não encontrada.')
              this.props.history.push('/painel-remarcacao')
              return
            }
            if (!['CANCELADO', 'CANCELADO_REEMBOLSO_EFETUADO'].includes(this.props.reserva.situacaoReserva)) {
              showErrorMsg('Reserva não está na situação cancelada.')
              this.props.history.push('/painel-remarcacao')
            }
          })
      } else {
        this.props.history.push('/painel-remarcacao')
      }
    }
  }

  limparMensagem () {
    this.setState({ mensagem: undefined })
  }

  limparFormulario () {
    this.props.reset('formReserva');
    this.limparMensagem();
  }

  fecharModal () {
    this.props.reset('formReserva');
    this.props.selecionarPedido(null);
  }

  groupArrayOfObjects (list, key) {
    return list.reduce((rv, x) => {
      // eslint-disable-next-line no-param-reassign
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  exibirDadosRota (reserva) {
    return <React.Fragment>
      <tr className="top">
        <td colSpan="3">Pedido: {this.props.reserva.pedidoId}</td>
      </tr>
      <tr>
        <td colSpan="3">Rota: {reserva.rota}</td>
      </tr>
      <tr>
        <td colSpan="3">Prefixo: {reserva.prefixoRota ? reserva.prefixoRota : 'Não informado'}</td>
      </tr>
      <tr>
        <td colSpan="3">Origem: {reserva.descCidadeOrigemAlternativa ? reserva.descCidadeOrigemAlternativa : reserva.descCidadeOrigem}</td>
      </tr>
      <tr>
        <td colSpan="3">Destino: {reserva.descCidadeDestinoAlternativa ? reserva.descCidadeDestinoAlternativa : reserva.descCidadeDestino}</td>
      </tr>
      <tr>
        <td colSpan="3">Data/Hora embarque: {reserva.dataHoraPartida}</td>
      </tr>
      <tr>
        <td colSpan="3">Tipo de Viagem: {reserva.descricaoTipoPreco}</td>
      </tr>
    </React.Fragment>
  }

  exibirPassageiros (reservas) {
    return reservas.map(it => this.exibirPassageiro(it))
  }

  exibirPassageiro (reserva) {
    return <React.Fragment key={reserva.passageiroDto.id}>
      <tr className="top">
        <td colSpan="3">Passageiro: {reserva.passageiroDto.nome}</td>
      </tr>
      <tr>
        <td colSpan="3">Poltrona: {reserva.numeroPoltrona}</td>
      </tr>
      <tr>
        <td colSpan="3">Tipo emissão: {reserva.passageiroDto.descTipoEmissao}</td>
      </tr>
      <tr>
        <td colSpan="3">CPF: {reserva.passageiroDto.cpfPassageiro}</td>
      </tr>
      <tr>
        <td colSpan="3">Doc. embarque: {reserva.passageiroDto.documentoComFoto}</td>
      </tr>
      {this.exibirDadosCrianca(reserva.passageiroDto)}
    </React.Fragment>
  }

  seCompradorPassageiro () {
    return this.props.pedido.reservas.filter(it => it.passageiroDto.cpfPassageiro === this.props.pedido.cpfCnpjComprador).length > 0
  }

  exibirCriacaColo (passageiro) {
    if (passageiro.criancaDto) {
      return <React.Fragment>
        {this.exibirDadosCrianca(passageiro)}
        <tr align="center">
          <td colSpan="3">
            <QRCode style={{
              width: 80,
              height: 80
            }}
                    value={`${passageiro.criancaDto.id}`}/>
          </td>
        </tr>
      </React.Fragment>
    }
    return null
  }

  exibirDadosCrianca (passageiro) {
    const crianca = passageiro.criancaDto;
    if (crianca) {
      return <React.Fragment>
        <tr className='top'>
          <td colSpan="3">Criança de colo: {crianca.nome}</td>
        </tr>
        <tr>
          <td colSpan="3">Poltrona: {passageiro.numeroPoltrona}</td>
        </tr>
        <tr>
          <td colSpan="3">Data nascimento criança: {crianca.dtNascimentoCrianca}</td>
        </tr>
        <tr>
          <td colSpan="3">Doc. embarque criança: {crianca.documentoCriacaComFoto}</td>
        </tr>
        {crianca.cpfCrianca
          ? <tr>
            <td colSpan="3">CPF criança: {crianca.cpfCrianca}</td>
          </tr> : ''}
      </React.Fragment>
    }
  }

  recuperarTaxaEmbarque () {
    const reservas = this.props.pedido.reservas.filter(t => t.taxaEmbarque);
    let valor = '0';
    if (reservas.length) {
      valor = reservas
        .map(v => v.taxaEmbarque)
        .reduce((sum, current) => Number(sum) + Number(current));
    }
    return formatarReal(valor.toString())
  }

  recuperarTarifa () {
    const valor = this.props.pedido.reservas
      .map(v => v.valor)
      .reduce((sum, current) => Number(sum) + Number(current));
    return formatarReal(valor.toString())
  }


  exibirBotaoImprimir () {
    return (
      <React.Fragment>
        <ReactToPrint
          trigger={() => <button className="btn btn-laranja">IMPRIMIR
          </button>}
          content={() => this.componentRef.current}
        />
      </React.Fragment>)
  }

  exibirCabecalho (label, nome, cpf) {
    return <React.Fragment>
      <tr>
        <th className="title" colSpan="3">
          {this.props.reserva.dadosEmpresa.nomeEmpresa}
          <br/>
          <strong>CNPJ: </strong><span>{this.props.reserva.dadosEmpresa.cnpjEmpresa}</span>
          <br/>
          <span className='text-center'>{`${this.props.reserva.dadosEmpresa.logradouro},
            ${this.props.reserva.dadosEmpresa.numero ? this.props.reserva.dadosEmpresa.numero : 'S/N'}
            ${this.props.reserva.dadosEmpresa.complemento ? `, ${this.props.reserva.dadosEmpresa.complemento}` : ''}`}
            {`${this.props.reserva.dadosEmpresa.bairro} - ${this.props.reserva.dadosEmpresa.localidade} - ${this.props.reserva.dadosEmpresa.uf}`}
            ,<strong> CEP:</strong>{this.props.reserva.dadosEmpresa.cep}
            </span>
        </th>
      </tr>
      <tr>
        <th colSpan="3">{this.props.reserva.dataVenda}</th>
      </tr>
      <tr>
        <th colSpan="3">
          {nome} <br/>
          {cpf}
        </th>
      </tr>
      <tr>
        <th className="ttu" colSpan="3">
          <b>{label}</b>
        </th>
      </tr>
    </React.Fragment>
  }

  exibirCupom (reserva, crianca) {
    return <div>
      <table className="printer-ticket">
        <thead>
        {this.exibirCabecalho('Recibo de Cancelamento', reserva.passageiroDto.nome, reserva.passageiroDto.cpfPassageiro)}
        </thead>
        <tbody>
        {this.exibirDadosRota(reserva)}
        {this.exibirPassageiro(reserva)}
        </tbody>
        {this.exibirTotaisReserva(reserva, crianca)}
      </table>
      {this.linha()}
    </div>
  }



  exibirTrBranca () {
    return <tr className="sup printer-element">
      <td colSpan="3">x
      </td>
    </tr>
  }

  exibirTotaisReserva (reserva, crianca) {
    return <tfoot>
    {!crianca && !this.ehGratuidadeTotal(reserva.passageiroDto.tipoEmissao) ? <React.Fragment>
      <tr className="sup ttu p--0">
        <td colSpan="3">
          <b>Totais</b>
        </td>
      </tr>
      <tr className="ttu">
        <td colSpan="2">Tarifa</td>
        <td align="right">{formatarReal(reserva.valor.toString())}</td>
      </tr>
      <tr className="ttu">
        <td colSpan="2">Taxa de embarque</td>
        <td align="right">{formatarReal(reserva.taxaEmbarque ? reserva.taxaEmbarque.toString() : '0')}</td>
      </tr>
      <tr className="ttu">
        <td colSpan="2">Taxa seguro</td>
        <td align="right">{formatarReal(reserva.tarifaSeguro ? reserva.tarifaSeguro.toString() : '0')}</td>
      </tr>
      <tr className="ttu">
        <td colSpan="2">Pedágio</td>
        <td align="right">{formatarReal(reserva.pedagio ? reserva.pedagio.toString() : '0')}</td>
      </tr>
      <tr className="ttu">
        <td colSpan="2">Valor Total</td>
        <td align="right">{formatarReal(reserva.taxaEmbarque
          ? (Number(reserva.taxaEmbarque) + Number(reserva.valor)).toString() : reserva.valor.toString())}</td>
      </tr>
      <tr className="ttu">
        <td colSpan="2">Taxa de Cancelamento</td>
        <td align="right">{formatarReal(this.props.reserva.custoCancelamento)}</td>
      </tr>
      <tr className="ttu">
        <td colSpan="2">Valor de Estorno</td>
        <td align="right">{formatarReal(this.props.reserva.valorEstorno)}</td>
      </tr>
      <tr className="ttu">
        <td colSpan="2">Forma de pagamento</td>
        <td align="right">{this.props.reserva.descricaoFormasPagamento}</td>
      </tr>
    </React.Fragment> : null}
    <tr className="sup">
      <td colSpan="3" align="center">
        <b>Vendedor: </b>{this.props.reserva.nomeVendedor}
      </td>
    </tr>
    </tfoot>
  }

  linha () {
    return <hr id='printPageButton' style={{
      borderStyle: 'dashed',
      borderWidth: 3
    }}/>
  }

  ehGratuidadeTotal (tipoEmissao) {
    return tipoEmissao === 'ID_JOVEM_100'
      || tipoEmissao === 'IDOSO_100'
      || tipoEmissao === 'DEFICIENTE'
      || tipoEmissao === 'P_LIVRE_POLICIAL_AUDITOR'
  }

  exibir () {
    return <React.Fragment>
      <div>
        <div>
          <div>
            {this.exibirCupom(this.props.reserva)}
          </div>
        </div>
      </div>
    </React.Fragment>
  }

  render () {
    if (!this.props.reserva) {
      return ''
    }
    return (
      <React.Fragment>
        <div className="row internas">
          <Titulo texto="Recibo de Cancelamento" urlRetorno='/painel-remarcacao'/>
          <div className='col-md-12 d-flex justify-content-center mb-2'>
            {this.exibirBotaoImprimir()}
          </div>
          <div className='col-md-12 d-flex justify-content-center'>
            <div ref={this.componentRef}>
              {this.exibir()}
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export function mapStateToProps (state) {
  return {
    pedido: state.pedido,
    empresaSelecionada: state.empresaSelecionada,
    reserva: state.reserva
  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    buscarReserva
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(ReciboCancelamentoReserva);
